export const zIndex = {
  layer: 1000,
  header: 10000,
  modal: 100000,
};